<template>
    <v-row justify="center">
        <v-dialog v-model="internalDialog" persistent max-width="800">
            <v-card>
                <v-toolbar color="primary">
                    <v-icon dark>mdi-email-lock-outline</v-icon>
                    <div style="color: white; margin-left: 10px;" class="text-h6">{{ title }}</div>
                </v-toolbar>

                <v-card-text>
                    <v-form ref="formCredenciais" v-model="formValidado">
                        <v-row v-if="modoDestinatarios === 'pessoas'">
                            <v-col cols="12">
                                <multipla-escolha
                                    lazy
                                    get-url="getGruposlazy"
                                    ref="gruposSelect"
                                    text="nome"
                                    value="id_grupo"
                                    :label="groupsLabel"
                                    can-toggle-all
                                    :selected-items="gruposSelected"
                                    @update:selectedItems="onGruposUpdate"
                                    @update:allMatchingSelected="onGruposAllMatching"
                                    @error="handleError"
                                />
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12">
                                <multipla-escolha
                                    v-if="modoDestinatarios === 'pessoas'"
                                    :items="pessoasComUsuario"
                                    ref="pessoasSelect"
                                    text="nome_completo"
                                    value="id_pessoa"
                                    :label="receiversLabel"
                                    can-toggle-all
                                    :rules="receiversRules"
                                    :selected-items="pessoasSelected"
                                    @update:selectedItems="pessoasSelected = $event"
                                    @error="handleError"
                                />
                                <multipla-escolha
                                    v-else
                                    :items="usuariosItems"
                                    ref="usuariosSelect"
                                    text="displayText"
                                    value="id_usuario"
                                    :label="receiversLabel"
                                    can-toggle-all
                                    :rules="receiversRules"
                                    :selected-items="usuariosSelected"
                                    @update:selectedItems="usuariosSelected = $event"
                                    @error="handleError"
                                />
                            </v-col>
                        </v-row>

                        <v-row v-if="!idMensagem">
                            <v-col cols="12">
                                <v-autocomplete
                                    v-model="templateSelected"
                                    :items="templatesCredenciais"
                                    item-text="descricao"
                                    item-value="id_template"
                                    return-object
                                    clearable
                                    :label="templateLabel"
                                    :rules="[(v) => !!v || templateRequiredMessage]"
                                >
                                    <template v-slot:item="{ item }">
                                        <v-list-item-content>
                                            <v-list-item-title>{{ item.descricao }}</v-list-item-title>
                                            <v-list-item-subtitle v-if="item.cod_template">
                                                {{ codeText }}: {{ item.cod_template }}
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                    </template>
                                </v-autocomplete>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12">
                                <v-alert
                                    v-if="canaisFiltrados.length === 0"
                                    type="warning"
                                    dense
                                    outlined
                                    text
                                >
                                    {{ noChannelsMessage }}
                                </v-alert>
                                <multipla-escolha
                                    v-else
                                    :items="canaisFiltrados"
                                    ref="canaisSelect"
                                    text="descricao_canal"
                                    value="id_canal"
                                    :label="channelsLabel"
                                    can-toggle-all
                                    :selected-items="canaisSelected"
                                    @update:selectedItems="canaisSelected = $event"
                                    @error="handleError"
                                />
                            </v-col>
                        </v-row>

                        <v-row v-if="validationWarnings.length > 0">
                            <v-col cols="12">
                                <v-alert type="warning" dense outlined text>
                                    <div v-for="(warning, index) in validationWarnings" :key="index">
                                        {{ warning }}
                                    </div>
                                </v-alert>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn dark color="primary" @click="handleCancel" :disabled="loading">{{ cancelText }}</v-btn>
                    <v-btn dark color="primary" @click="handleSend" :loading="loading">{{ sendText }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import apiController from '@/utils/apiController';
import MultiplaEscolha from '../Selects/MultiplaEscolha.vue';
import translateDbField from '@/utils/translateDbField';
import EventBus from '../../utils/eventBus';

const COD_TEMPLATE_PADRAO = 'SYS-CRED';

export default {
    name: 'EnvioCredenciaisDialog',
    components: {
        MultiplaEscolha,
    },
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        token: {
            type: String,
            required: true,
        },
        user: {
            type: Object,
            required: true,
        },
        setup: {
            type: Object,
            default: () => ({
                has_email: 0,
                has_sms: 0,
                has_whatsapp: 0,
                has_google_chat: 0,
            }),
        },
        modoDestinatarios: {
            type: String,
            default: 'usuarios',
            validator: (v) => ['usuarios', 'pessoas'].includes(v),
        },
        usuariosPreSelecionados: {
            type: Array,
            default: () => [],
        },
        idMensagem: {
            type: [Number, String],
            default: null,
        },
        codTemplate: {
            type: String,
            default: COD_TEMPLATE_PADRAO,
        },
        title: {
            type: String,
            default: '',
        },
        groupsLabel: {
            type: String,
            default: '',
        },
        receiversLabel: {
            type: String,
            default: '',
        },
        channelsLabel: {
            type: String,
            default: '',
        },
        templateLabel: {
            type: String,
            default: '',
        },
        templateRequiredMessage: {
            type: String,
            default: '',
        },
        codeText: {
            type: String,
            default: '',
        },
        noChannelsMessage: {
            type: String,
            default: '',
        },
        cancelText: {
            type: String,
            default: '',
        },
        sendText: {
            type: String,
            default: '',
        },
        formValid: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            loading: false,
            formValidado: false,
            gruposSelected: [],
            pessoas: [],
            pessoasSelected: [],
            usuariosSelected: [],
            canais: [],
            canaisSelected: [],
            templates: [],
            templateSelected: null,
        };
    },
    computed: {
        internalDialog: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            },
        },
        usuariosItems() {
            return this.usuariosPreSelecionados.map((u) => ({
                ...u,
                displayText: `${u.nome_usuario || ''} (${u.login || ''})`,
            }));
        },
        pessoasComUsuario() {
            return this.pessoas.filter((p) => p.id_usuario);
        },
        templatesCredenciais() {
            return this.templates.filter((t) => {
                const corpo = t.corpo || '';
                return corpo.includes('{{1}}') && corpo.includes('{{2}}') && corpo.includes('{{3}}');
            });
        },
        canaisFiltrados() {
            const temTemplateMeta = this.templateSelected &&
                this.templateSelected.id_template_meta != null &&
                this.templateSelected.id_template_meta !== undefined;

            return this.canais.filter((canal) => {
                if (canal.id_canal === 1 || canal.id_canal === 4) {
                    return false;
                }
                if (canal.id_canal === 5 && !temTemplateMeta) {
                    return false;
                }
                return true;
            });
        },
        receiversRules() {
            return [
                (v) => (Array.isArray(v) && v.length > 0) || this.$t('credentials.dialog.selectAtLeastOneReceiver'),
            ];
        },
        validationWarnings() {
            const warnings = [];
            if (this.modoDestinatarios === 'usuarios') {
                const semEmail = this.usuariosItems.filter(
                    (u) => this.usuariosSelected.includes(u.id_usuario) && !u.email_recuperacao
                );
                if (semEmail.length > 0 && this.canaisSelected.includes(3)) {
                    warnings.push(this.$t('credentials.dialog.usersWithoutEmail', { count: semEmail.length }));
                }
            } else {
                const semUsuario = this.pessoas.filter(
                    (p) => this.pessoasSelected.includes(p.id_pessoa) && !p.id_usuario
                );
                if (semUsuario.length > 0) {
                    warnings.push(this.$t('credentials.dialog.peopleWithoutUser', { count: semUsuario.length }));
                }
            }
            return warnings;
        },
        resolvedIdUsuarios() {
            if (this.modoDestinatarios === 'pessoas') {
                const mapa = {};
                this.pessoas.forEach((p) => {
                    if (p.id_usuario) {
                        mapa[p.id_pessoa] = p.id_usuario;
                    }
                });
                return this.pessoasSelected
                    .map((idPessoa) => mapa[idPessoa])
                    .filter((id) => id != null);
            }
            return [...this.usuariosSelected];
        },
    },
    watch: {
        value(open) {
            if (open) {
                this.initializeDialog();
            }
        },
        gruposSelected() {
            this.loadPessoasPorGrupo();
        },
    },
    methods: {
        initializeDialog() {
            this.usuariosSelected = this.usuariosPreSelecionados.map((u) => u.id_usuario);
            this.pessoasSelected = [];
            this.gruposSelected = [];
            this.canaisSelected = this.setup.has_email == 1 ? [3] : [];
            this.formValidado = false;
            this.loadCanais();
            if (!this.idMensagem) {
                this.loadTemplates();
            }
            this.$nextTick(() => {
                this.syncSelectsFromState();
            });
        },
        syncSelectsFromState() {
            if (this.$refs.usuariosSelect) {
                this.$refs.usuariosSelect.setSelectedItems(this.usuariosSelected);
            }
            if (this.$refs.pessoasSelect) {
                this.$refs.pessoasSelect.setSelectedItems(this.pessoasSelected);
            }
            if (this.$refs.gruposSelect) {
                this.$refs.gruposSelect.setSelectedItems(this.gruposSelected);
            }
            if (this.$refs.canaisSelect) {
                this.$refs.canaisSelect.setSelectedItems(this.canaisSelected);
            }
        },
        loadPessoasPorGrupo() {
            if (this.gruposSelected.length === 0) {
                this.pessoas = [];
                return;
            }
            apiController.request(apiController.endpoints.getPessoasporgrupo, {
                data: this.gruposSelected,
                onSuccess: (response) => {
                    this.pessoas = response.data;
                }
            });
        },
        loadCanais() {
            apiController.request(apiController.endpoints.getallCanaiscomunicacao, {
                onSuccess: (response) => {
                    const canaisAtivos = response.data.filter((canal) => {
                        switch (canal.id_canal) {
                            case 2:
                                return this.setup.has_sms == 1;
                            case 3:
                                return this.setup.has_email == 1;
                            case 5:
                                return this.setup.has_whatsapp == 1;
                            default:
                                return false;
                        }
                    });
                    this.canais = canaisAtivos.map((canal) => ({
                        ...canal,
                        descricao_canal: translateDbField(canal.translation_key, canal.descricao_canal),
                    }));
                    this.$nextTick(() => {
                        if (this.$refs.canaisSelect) {
                            this.$refs.canaisSelect.setSelectedItems(this.canaisSelected);
                        }
                    });
                }
            });
        },
        loadTemplates() {
            apiController.request(apiController.endpoints.getallTemplatesmensagens, {
                onSuccess: (response) => {
                    this.templates = response.data;
                    const padrao = this.templates.find((t) => t.cod_template === this.codTemplate);
                    this.templateSelected = padrao || this.templatesCredenciais[0] || null;
                }
            });
        },
        onGruposUpdate(value) {
            this.gruposSelected = value;
        },
        // "Todos" no modo lazy não emite ids; resolve todos os grupos para carregar as pessoas.
        async onGruposAllMatching(todos) {
            if (!todos || !this.$refs.gruposSelect) return;
            this.gruposSelected = await this.$refs.gruposSelect.resolveSelection();
        },
        handleError(error) {
            EventBus.$emit('show-alert', { mensagem: error, tipo: 'error' });
        },
        handleCancel() {
            this.$emit('cancel');
            this.internalDialog = false;
        },
        handleSend() {
            const formValid = this.$refs.formCredenciais
                ? this.$refs.formCredenciais.validate()
                : false;
            if (!formValid) {
                return;
            }

            const canais = [...this.canaisSelected];
            if (canais.length === 0) {
                EventBus.$emit('show-alert', {
                    mensagem: this.$t('credentials.dialog.selectAtLeastOneChannel'),
                    tipo: 'warning',
                });
                return;
            }

            const idUsuarios = [...new Set(this.resolvedIdUsuarios)];
            if (idUsuarios.length === 0) {
                EventBus.$emit('show-alert', {
                    mensagem: this.$t('credentials.dialog.selectAtLeastOneReceiver'),
                    tipo: 'warning',
                });
                return;
            }

            const payload = {
                idUsuarios,
                canais,
                idUsuarioEnvio: this.user,
            };

            if (this.idMensagem) {
                payload.idMensagem = this.idMensagem;
            } else if (this.templateSelected) {
                payload.idTemplate = this.templateSelected.id_template;
                payload.codTemplate = this.templateSelected.cod_template;
            } else {
                payload.codTemplate = this.codTemplate;
            }

            this.loading = true;
            apiController.request(apiController.endpoints.enviacredenciais, {
                data: payload,
                onSuccess: (response) => {
                    this.loading = false;
                    const data = response.data;
                    let mensagem = this.$t('credentials.dialog.sendSuccess', { count: data.enviados || 0 });
                    if (data.falhas && data.falhas.length > 0) {
                        mensagem += ' ' + this.$t('credentials.dialog.partialFailures', { count: data.falhas.length });
                    }
                    EventBus.$emit('show-alert', { mensagem, tipo: data.falhas && data.falhas.length > 0 ? 'warning' : 'success' });
                    if (data.id_processo_email) {
                        EventBus.$emit('scheduler-download-enqueued');
                    }
                    this.$emit('sent', data);
                    this.internalDialog = false;
                },
                onError: () => {
                    this.loading = false;
                }
            });
        },
        validate() {
            if (this.$refs.formCredenciais) {
                return this.$refs.formCredenciais.validate();
            }
            return false;
        },
        resetValidation() {
            if (this.$refs.formCredenciais) {
                this.$refs.formCredenciais.resetValidation();
            }
        },
    },
};
</script>
